import { useContext, useEffect } from "react";
import { BackButton } from "../../components/BackButton";
import ButtonSelect, { StringStringOption } from "../../components/ButtonSelect";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { saveStateRemote } from "../../utils/api";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";

const AccomodationTypeStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();
  
  const accomodationTypeOptions : StringStringOption[] = [
    { value: 'OWN_PROPERTY', label: 'Eget hus' },
    { value: 'CONDOMINIUM', label: 'Ejerlejlighed' },
    { value: 'RENTAL', label: 'Lejebolig' },
    { value: 'HOUSING_COOPERATIVE', label: 'Andelsbolig' },
    { value: 'WITH_PARENTS', label: 'Hjemmeboende' },
    { value: 'ROOMER', label: 'Lejet værelse' },
    { value: 'OTHER', label: 'Anden' },
  ];

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'AccomodationType' } });
    dispatch({ type: 'set_step', step: Step.AccomodationType });
    scrollToTopOfContent();

    const saveState = async () => { await saveStateRemote(state); }
    saveState();
  }, []);

  const onOptionSelected = (option: StringStringOption) => {
    dispatch({type:'set_accomodationtype', values: option.value })
    navigate('/bolig-indflytning')
  };

  return (
    <>
      <h2>Nuværende boligform</h2>

      <div className="mt-5">
        <ButtonSelect
          options={accomodationTypeOptions}
          onOptionSelected={(option) => onOptionSelected(option)}
          option={undefined}
          getOptionText={(option) => {
            return option.label;
          }}
          getOptionKey={(option) => {
            return option.value;
          }}
        ></ButtonSelect>
      </div>

      

      <div className="container-btn">
        <BackButton />
      </div>
    </>
  );
};

export default AccomodationTypeStep;
